import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { preserveMathCursorPosition } from "@/components/tiptap/utils/preserveMathCursorPosition";

import type { DocumentModel } from "@/models/DocumentModel";
import type { ComponentProps } from "react";

type Props = {
  doc: DocumentModel;
} & ComponentProps<"button">;

export const MathIndentationButton = observer(function MathIndentationButton({
  doc,
  ...props
}: Props) {
  const { tiptap } = doc.editor;
  const t = useTranslations("sidebar");

  if (!tiptap) {
    return null;
  }

  const { hasMathIndentation } = doc.editor.editorState;

  const handleAlignmentChange = () => {
    preserveMathCursorPosition(doc, () => {
      tiptap.chain().setMathIndentation(!hasMathIndentation).run();
    });
  };

  return (
    <Sidebar.Button
      icon={<Icon name="AlignMath" />}
      aria-label={t("textStyle.alignMath")}
      title={t("textStyle.alignMath")}
      className="w-9.5"
      isActive={hasMathIndentation}
      onClick={handleAlignmentChange}
      hintKey="mathAlign"
      inverted
      {...props}
    />
  );
});
